import { Link } from "react-router-dom";
import { Instagram, Facebook, MapPin } from "lucide-react";
import { BOOK_URL } from "@/lib/booking";
const SOCIALS = [
  {
    label: "Instagram",
    href: "https://www.instagram.com/thepropertycuratorwarwickshire?igsh=c2l4YTV1ZTA2cDR5",
    Icon: Instagram,
    handle: "@thepropertycuratorwarwickshire",
  },
  {
    label: "Facebook",
    href: "https://www.facebook.com/share/18pdc5wCWY/",
    Icon: Facebook,
    handle: "The Property Curator",
  },
  {
    label: "Google",
    href: "https://share.google/I6fV482JdoGpX3LXU",
    Icon: MapPin,
    handle: "Find me on Google",
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#0B1215] text-[#F8F9FA] grain relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 relative z-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-10">
          <h2 className="font-display text-6xl sm:text-7xl lg:text-8xl tracking-tighter leading-none">
            Let's<br />
            <span className="italic font-light">work.</span>
          </h2>
          <a
            href={BOOK_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-[#FF5A36] hover:bg-[#E04928] text-[#F8F9FA] px-8 py-4 font-mono-label active:scale-95 transition-all"
            data-testid="footer-cta"
          >
            Book a slot →
          </a>
        </div>

        <div className="mt-16 pb-10 border-b border-[#F8F9FA]/10">
          <div className="font-mono-label text-[#FF5A36] mb-5">· FOLLOW THE WORK</div>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-3" data-testid="social-links">
            {SOCIALS.map(({ label, href, Icon, handle }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 border border-[#F8F9FA]/15 hover:border-[#FF5A36] hover:bg-[#FF5A36]/5 px-5 py-4 transition-colors"
                data-testid={`social-${label.toLowerCase()}`}
              >
                <div className="w-10 h-10 bg-[#F8F9FA]/5 group-hover:bg-[#FF5A36] flex items-center justify-center transition-colors shrink-0">
                  <Icon size={18} strokeWidth={1.6} />
                </div>
                <div className="min-w-0">
                  <div className="font-mono-label text-[#F8F9FA]/50 group-hover:text-[#FF5A36] transition-colors">· {label.toUpperCase()}</div>
                  <div className="font-display text-base tracking-tight truncate">{handle}</div>
                </div>
              </a>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-8 pb-10 border-b border-[#F8F9FA]/10">
          <div>
            <div className="font-mono-label text-[#FF5A36] mb-3">· COMPANY</div>
            <div className="font-display text-lg leading-tight">The Property Curator</div>
            <div className="font-mono-label text-[#F8F9FA]/50 mt-1" style={{ textTransform: "lowercase", letterSpacing: "0.12em" }}>
              (warwickshire and surrounding areas)
            </div>
          </div>
          <div>
            <div className="font-mono-label text-[#FF5A36] mb-3">· COVERAGE</div>
            <div className="text-sm text-[#F8F9FA]/70">Warwickshire<br />& surrounding areas, UK</div>
          </div>
          <div>
            <div className="font-mono-label text-[#FF5A36] mb-3">· GET IN TOUCH</div>
            <a href="tel:+447346812685" className="block text-sm hover:text-[#FF5A36]">07346 812 685</a>
            <a href="mailto:rob@thepropertycuratorwarwickshire.co.uk" className="block text-sm hover:text-[#FF5A36] mt-1 break-all">
              rob@thepropertycuratorwarwickshire.co.uk
            </a>
            <a href="https://thepropertycuratorwarwickshire.co.uk" className="block text-sm hover:text-[#FF5A36] mt-1">
              thepropertycuratorwarwickshire.co.uk
            </a>
          </div>
          <div>
            <div className="font-mono-label text-[#FF5A36] mb-3">· LINKS</div>
            <Link to="/services" className="block text-sm hover:text-[#FF5A36]">Services</Link>
            <Link to="/pricing" className="block text-sm hover:text-[#FF5A36] mt-1">Pricing</Link>
            <Link to="/work" className="block text-sm hover:text-[#FF5A36] mt-1">Work</Link>
            <Link to="/reviews" className="block text-sm hover:text-[#FF5A36] mt-1">Reviews</Link>
            <Link to="/areas" className="block text-sm hover:text-[#FF5A36] mt-1">Areas</Link>
            <Link to="/faq" className="block text-sm hover:text-[#FF5A36] mt-1">FAQ</Link>
            <Link to="/admin/login" className="block text-sm hover:text-[#FF5A36] mt-1 opacity-40" data-testid="footer-admin-link">
              Admin
            </Link>
          </div>
        </div>

        <div className="mt-8 flex flex-col md:flex-row justify-between items-start md:items-center gap-3 text-sm text-[#F8F9FA]/50">
          <div>© {new Date().getFullYear()} The Property Curator. All rights reserved.</div>
          <div className="font-mono-label">· QUALIFIED · INSURED · LOCAL</div>
        </div>
      </div>
    </footer>
  );
}
